module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/artillery-battalion-lvl1-75.8c428335.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/artillery-battalion-lvl1-75.png
// module id = 3498
// module chunks = 11